module.exports = __webpack_public_path__ + "static/media/weekly-statistics-active-icon.c81ab7d8.svg";